// Trustpilot TrustBox with fallback (mockup 9c): the dated, linked fallback rating stays visible until
// Trustpilot's iframe loads; then the live widget is shown and exposed to assistive tech.
if (!customElements.get('pv-trustbox')) {
  class PvTrustbox extends HTMLElement {
    connectedCallback() {
      this.widget = this.querySelector('.trustpilot-widget');
      this.fallback = this.querySelector('.trustbox-fallback');
      if (!this.widget || typeof MutationObserver === 'undefined') return;

      this.observer = new MutationObserver(() => this.watchFrame());
      this.observer.observe(this.widget, { childList: true, subtree: true });
      this.watchFrame();

      // Section re-rendered in the theme editor after the bootstrap script already ran.
      if (window.Trustpilot && !this.widget.querySelector('iframe')) {
        window.Trustpilot.loadFromElement(this.widget, true);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    watchFrame() {
      const frame = this.widget.querySelector('iframe');
      if (!frame || frame.dataset.observed) return;
      frame.dataset.observed = 'true';
      frame.title = this.widget.getAttribute('aria-label') || 'Customer rating on Trustpilot';
      frame.addEventListener(
        'load',
        () => {
          this.classList.add('trustbox-loaded');
          this.widget.removeAttribute('aria-hidden');
          this.fallback.hidden = true;
          this.observer.disconnect();
        },
        { once: true }
      );
    }
  }

  customElements.define('pv-trustbox', PvTrustbox);
}
